import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
                               icons: {
                                   iconfont: 'md'
                               },
                               theme: {
                                   themes: {
                                       light: {
                                           primary: "#11172B",
                                           dark_primary: "#3F413C",
                                           secondary: "#d7c700",
                                           green: "#94a545",
                                           orange: "#ea8a1a",
                                           red: "#c01933",
                                           yellow: "#d7c700"
                                           //secondary: "#c64f85"
                                           //secondary: "#c66f4f"
                                       }
                                   }
                               }

});
